import { atom } from 'recoil';
import defaultStatistics from 'ProjectManager/Project/List/recoil/statistics/defaultStatistics';

const projectsStatisticsAtom = atom({
    key: 'projectManagement_projectsListStatistics',
    default: defaultStatistics,
});

export default projectsStatisticsAtom;
